<div class="form-group">
  <div [hidden]="tocado" class="row">
    <div class="col-md-12">
      <mat-form-field>
        <mat-label>{{ label }}</mat-label>
        <input
          type="text"
          value="{{ selectedPrevName }}"
          matInput
          [placeholder]="id"
          (click)="cambiar()"
        />
      </mat-form-field>
    </div>
  </div>

  <div [hidden]="!tocado" class="row">
    <div class="col-md-12">
      <mat-form-field class="example-full-width">
        <mat-label>{{ label }}</mat-label>
        <input
          type="text"
          name="opt"
          [(ngModel)]="optionSelected"
          [placeholder]="plholder"
          aria-label="Search"
          matInput
          [formControl]="myControl"
          [matAutocomplete]="autoOptions"
          [id]="id"
        />
        <mat-autocomplete
          (optionSelected)="OnHumanSelected($event.option)"
          #autoOptions="matAutocomplete"
          [displayWith]="displayFn"
        >
          <mat-option
            *ngFor="let option of filteredOptions | async"
            [value]="option"
            [disabled]="deshabilitar(option)"
          >
            <span class="{{ deshabilitar(option) ? 'deshabilitar' : '' }}">{{
              option.name
            }}</span>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
  </div>
</div>
